module.exports = __webpack_public_path__ + "static/4-3b7275edd89fa1362e7cf7de9ef59e3d.jpeg";